import React, { useState, useEffect } from 'react'
import Icon from '../../../shared/components/atoms/Icon/Icon'
import InputWebinar from '../../atoms/input-webinar/input-webinar'
import './form-loyalty.scss'
import Loader from 'react-loader-spinner'
import DataPolicy from '../../../shared/components/molecules/data-policy/data-policy'
import useCities from '../../../shared/hooks/useCities'
import RegisterService from '../../../shared/services/register'
import WebinarService from '../../../shared/services/webinar'
import { useForm } from "react-hook-form"
import { INLINES } from "@contentful/rich-text-types"
import { documentToReactComponents } from "@contentful/rich-text-react-renderer"
import CheckboxAtom from "../../../shared/components/atoms/checkbox/checkbox"

const FormLoyalty = props => {
    const { userInfoPreload, setstepState } = props;
    // console.log(props)
    const citiesInfo = useCities();

    const genderOptions = [
        {
            value: 'Femenino',
            label: 'Femenino'
        },
        {
            value: 'Masculino',
            label: 'Masculino'
        },
        {
            value: 'Prefiero no responder',
            label: 'Prefiero no responder'
        },
    ]

    const EMAIL_RX = /(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])/

    const cityLabel = citiesInfo.nombreCiudad
    const countryStateLabel = citiesInfo.nombreDepartamento

    const [isLoading, setisLoading] = useState(false)

    const countryStateOptions = citiesInfo.departamentos.map(e => ({ value: e.codigo, label: e.nombre }))
    const [citiesOptions, setcitiesOptions] = useState([])

    const [isProspect, setisProspect] = useState(false)

    //Values
    const [name, setname] = useState('')
    const [lastName, setlastName] = useState('')
    const [email, setemail] = useState('')
    const [gender, setgender] = useState('')
    const [country, setcountry] = useState('')
    const [countryState, setcountryState] = useState('')
    console.log("🚀 ~ file: form-loyalty.jsx ~ line 54 ~ countryState", countryState)
    const [phone, setphone] = useState('')
    const [city, setcity] = useState('')
    const [address, setaddress] = useState('')
    const [password, setpassword] = useState('')

    //Errors
    const [nameError, setnameError] = useState(false)
    const [lastNameError, setlastNameError] = useState(false)
    const [emailError, setemailError] = useState(false)
    const [phoneError, setphoneError] = useState('')
    const [genderError, setgenderError] = useState(false)
    // const [countryError, setcountryError] = useState(false)
    const [countryStateError, setcountryStateError] = useState(false)
    const [cityError, setcityError] = useState(false)
    const [addressError, setaddressError] = useState(false)
    // const [rolError, setrolError] = useState(false)
    const [passwordError, setpasswordError] = useState(false)

    const {
        register,
        triggerValidation,
        errors,
        formState,
        getValues
      } = useForm({
        mode: "onBlur",
        reValidateMode: "onChange",
      })
    
    
    useEffect(() => {
        getCountryParam()
        preloadUserInfo()

        //PR no stateCountry
        // if (process.env.LOCALE !== 'es-PR') {
        //     setcitiesOptions(citiesInfo.departamentos.map(m => ({ value: m.codigo, label: m.nombre })))
        // }
    }, [])

    const handleGetDownloadCertificate = _userId => {
        let config = {
            responseType: 'blob'
        }
        WebinarService.getCertificate(props.webinarId, _userId, config).then(resp => {
            if (resp.status === 200) {
                setisLoading(false)
                const file = new Blob([resp.data], { type: 'application/pdf' });
                const fileURL = window.URL.createObjectURL(file);
                const link = document.createElement('a');
                document.body.appendChild(link);
                link.href = fileURL;
                link.download = "Certificado.pdf";
                link.click();
                setstepState('stepSuccessLoyalty');
            }
            else if (resp.status === 202) {
                const blb = new Blob([resp.data], { type: "text/plain" });
                const reader = new FileReader();

                reader.addEventListener('loadend', (e) => {
                    const jsonResponse = JSON.parse(e.srcElement.result);
                    setisLoading(false);
                    if (jsonResponse.status === 500) {
                        props.setModalAlertVisibility(true);
                        props.setModalAlertText("Tenemos un error generando el certificado, inténtalo de nuevo más tarde.");
                    } else {
                        props.setModalAlertVisibility(true);
                        props.setModalAlertText(jsonResponse.userMessage)
                    }
                });

                reader.readAsText(blb);
            }
        })
            .catch(err => {
                setisLoading(false);
                let event = new CustomEvent("errorServiceModal", { "detail": 'Lo sentimos, tenemos un error generando el certificado, inténtalo de nuevo más tarde.' });
                document.dispatchEvent(event);
            })
    }

    const getCountryParam = () => {
        // let url_string = window.location.href;
        // let url = new URL(url_string);
        // let country = url.searchParams.get("c");
        // setcountry(country === 'py' ? 'PARAGUAY' : process.env.COUNTRY_NAME)
        setcountry(process.env.COUNTRY_NAME)

        // if (country === 'py') {
        //     setisPY(true)
        // }
    }

    const getCountryStateByCity = code => {
        let codeCountryState = citiesInfo.ciudades.filter(c => parseInt(c.codigo) === code)[0].codigoDepartamento
        let countryStateName = citiesInfo.departamentos.filter(d => parseInt(d.codigo) === parseInt(codeCountryState))[0].codigo

        return countryStateName
    }

    const preloadUserInfo = () => {
        let userData = userInfoPreload
        console.log("🚀 ~ file: form-loyalty.jsx ~ line 157 ~ preloadUserInfo ~ userData", userData)
        // let userData = mockInfo

        let url_string = window.location.href;
        let url = new URL(url_string);
        let country = url.searchParams.get("c");

        if (userData.name) {
            setname(userData.name)
        }

        if (userData.lastName) {
            setlastName(userData.lastName)
        }

        if (userData.email) {
            setemail(userData.email)
        }

        if (userData.gender) {
            setgender(userData.gender)
        }

        // if (userData.departamentId) {
        //     if (process.env.LOCALE !== 'es-PR') {
        //         handleChangeCountryState(userData.departamentId.toString())
        //     }
        // }
        
        // if (userData.city) {
        //     setcity(userData.city)
        // }

        if (userData.cellPhone) {
            setphone(userData.cellPhone.slice((country === 'py' ? pyInfo.COUNTRY_PHONE_PREFIX.length : process.env.COUNTRY_PHONE_PREFIX.length), userData.cellPhone.length))
        }
        let isProspect = userData.state && userData.segment && (userData.segment === 'PROSPECTO' || userData.state === 'MIGRACION' || userData.state === 'TEMPORAL');
        setisProspect(isProspect);

        if (userData.address) {
            setaddress(userData.address)
        }
    }

    const handleOnSubmit = e => {
        e.preventDefault()
        if (!haveErrors()) {
            setisLoading(true)
            let data = getValues()
            let payload = {
                name: name,
                lastName: lastName,
                email: email,
                cellPhone: process.env.COUNTRY_PHONE_PREFIX + phone,
                tycAccepted: 1,
                uytdAccepted: 1,
                // pbAccepted: 1,
                verificationMode: userInfoPreload.verificationMode,
                // birthdate: `${data.date}/${values.month}/${data.year}`,
                password: isProspect ? password : null,
                samples: null,
                country: process.env.COUNTRY_CODE,
                countryRegisterId: process.env.COUNTRY_CODE,
                fromBenefits: false,
                contactAccepted: true,
                userId: userInfoPreload.userId,
                segment: userInfoPreload.segment,
                // userId: mockInfo.userId,
                // segment: mockInfo.segment,
                rolesName: isProspect ? ["CUIDADOR_PROFESIONAL"] : userInfoPreload.rolesName,
                gender: gender,
                city: city,
                countryState: countryState,
                address: address,
            }

            props.checksAceptoDePoliticas?.forEach(({ idEtiqueta }) => {
                payload[idEtiqueta] = data[idEtiqueta] ? 1 : 0
            })

            RegisterService.firstRegister(payload).then(res => {
                if (res.status === 200) {
                    handleGetDownloadCertificate(payload.userId);
                } else if (res.status === 400) {
                    setphoneError('Este teléfono ya fue registrado')
                    setisLoading(false)
                } else {
                    console.log(res);
                    setisLoading(false)
                }
            })
        }
    }

    const haveErrors = () => {
        if (!name || name === ' ') {
            setnameError('Debes llenar este campo')
        } else {
            setnameError(false)
        }

        if (!lastName || lastName === ' ') {
            setlastNameError('Debes llenar este campo')
        } else {
            setlastNameError(false)
        }

        if (!phone) {
            setphoneError('Debes llenar este campo')
        } else {
            if (!phone.match(/^[0-9]*$/i) || phone.length !== parseInt(process.env.CELL_DIG)) {
                setphoneError('Número inválido')
            } else {
                setphoneError(false)
            }
        }

        if (!email) {
            setemailError('Debes llenar este campo')
        } else {
            if (!email.match(EMAIL_RX)) {
                setemailError('El correo no es válido')
            } else {
                setemailError(false)
            }
        }

        if (!gender) {
            setgenderError('Debes llenar este campo')
        } else {
            setgenderError(false)
        }

        if (isProspect) {
            if (!password) {
                setpasswordError('Debes llenar este campo')
            } else {
                if (password.length < 6) {
                    setpasswordError('La contraseña es muy corta')
                } else {
                    setpasswordError(false)
                }
            }
        }

        if (!address) {
            setaddressError('Debes llenar este campo')
        } else {
            setaddressError(false)
        }

        if (!countryState) {
            setcountryStateError('Debes llenar este campo')
        } else {
            setcountryStateError(false)
        }

        if (process.env.LOCALE !== 'es-PR') {
            if (!city) {
                setcityError('Debes llenar este campo')
            } else {
                setcityError(false)
            }
        }

        return (
            (!name || name === ' ') ||
            (!lastName || lastName === ' ') ||
            (!phone ? true : (!phone.match(/^[0-9]*$/i) || phone.length !== parseInt(process.env.CELL_DIG))) ||
            (!email ? true : (!email.match(EMAIL_RX))) ||
            (!address) || (process.env.LOCALE === 'es-PR' ? false : !city) ||
            (!countryState) ||
            (!isProspect ? false : (!password ? true : (password.length < 6)))
        )
    }

    const handleChangeCountryState = value => {
        setcountryState(value)
        if (process.env.LOCALE !== 'es-PR') {
            setcitiesOptions(
                citiesInfo.ciudades.filter(e => e.codigoDepartamento === value).map(m => ({ value: m.codigo, label: m.nombre }))
            )
        }
    }

    const optionsChecks = {
        renderNode: {
          [INLINES.HYPERLINK]: (node, next) => {
            return <a
              href={node.data.uri}
              rel="noopener noreferrer"
              target="_blank"
            >
              {next}
            </a>
          },
        },
      }

    return (
        <form className="f-loyalty-form" onSubmit={handleOnSubmit} autoComplete='off'>

            <div className="f-form-row-group">

                <InputWebinar
                    label='Nombre'
                    placeholder='Ej: Diana'
                    error={nameError}
                    onChange={e => setname(e.replace(/ {2}/g, ' '))}
                    value={name}
                />
                <span />
                <InputWebinar
                    label='Apellido'
                    placeholder='Ej: Ramirez'
                    error={lastNameError}
                    onChange={e => setlastName(e.replace(/ {2}/g, ' '))}
                    value={lastName}
                />
            </div>
            <InputWebinar
                label='Celular'
                placeholder={'Ej: ' + '3003984754'.slice(0, process.env.CELL_DIG)}
                error={phoneError}
                onChange={e => setphone(e.replace(/\D/g, '').slice(0, process.env.CELL_DIG))}
                value={phone}
            />
            <InputWebinar
                label='Email'
                placeholder='ejemplo@mail.com'
                error={emailError}
                onChange={e => setemail(e.replace(/ /g, ''))}
                value={email}
            />

            <InputWebinar
                label='Género'
                type='select'
                options={genderOptions}
                placeholder={gender && gender !== '' ? gender : 'Selecciona una opción'}
                error={genderError}
                onChange={setgender}
                value={gender}
            />

            <div className="f-form-row-group">
                <InputWebinar
                    label='Pais'
                    value={country}
                    disabled={true}
                // error={errorname}
                // onChange={e => setcountry(e)}
                />
                <span />
                <InputWebinar
                    label={countryStateLabel}
                    placeholder={countryStateLabel}
                    type='select'
                    options={countryStateOptions}
                    error={countryStateError}
                    onChange={handleChangeCountryState}
                    value={countryState}
                />
            </div>

            <div className="f-form-row-group">
                {process.env.LOCALE !== 'es-PR' &&
                    <>
                        <InputWebinar
                            label={cityLabel}
                            placeholder={cityLabel}
                            type='select'
                            options={citiesOptions}
                            error={cityError}
                            onChange={setcity}
                            value={city}
                        />
                        <span />
                    </>
                }
                <InputWebinar
                    label='Dirección'
                    placeholder='Calle 12 # 58-50'
                    error={addressError}
                    onChange={e => setaddress(e.replace(/ {2}/g, ' '))}
                    value={address}
                />
            </div>

            {isProspect && <InputWebinar
                label='Contraseña'
                type='password'
                error={passwordError}
                onChange={e => setpassword(e)}
                value={password}
            />}


            <div className="f-form-row-group">
              {props.checksAceptoDePoliticas?.map(
                ({ idEtiqueta, informacinPrincipal }, index) => {
                  return (
                    <CheckboxAtom
                      key={index}
                      errors={errors}
                      name={idEtiqueta}
                      showMessageError={false}
                      register={register({
                        required: "Debes seleccionar este campo",
                      })}
                      onChange={() => {
                            preloadUserInfo()
                          triggerValidation(idEtiqueta)
                        }}
                      label={
                        <>{documentToReactComponents(informacinPrincipal.json, optionsChecks)}</>
                      }
                    />
                  )
                }
              )}
            </div>

            <div className="f-data-policy-container">
                <DataPolicy  />
            </div>

            {!isLoading ?
                <button className="f-webinar-form__button" type="submit" disabled={(isLoading || !formState.isValid)}>
                    ENVIAR
                </button>
                :
                <div className="f-loader-container">
                    <Loader
                        type="Oval"
                        color="#003784"
                        height={50}
                        width={50}
                    />
                </div>
            }
        </form>
    )
}

export default FormLoyalty
